import React from "react";
import Certificatecarousel from "./Certificatecarousel"

const Certificates = () => {
    return (
        <div id="certificate" className="certificate">
                <h1>Certificates</h1>
                <div className="container">
                    <div className="certificate-content">
                        <Certificatecarousel />
                    </div>
                </div>
        </div>
    )
}

export default Certificates
